export default "__VITE_ASSET__DWqLDfwR__"